import { render, staticRenderFns } from "./LawEventTypeForm.vue?vue&type=template&id=5530921c&"
import script from "./LawEventTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawEventTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawEventTypeForm.vue?vue&type=style&index=0&id=5530921c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports